import { Button, Modal, Form, Input, message } from 'antd';
import styles from './index.module.scss';
import { getEmailCode, checkEmailCode } from "@/apis/user";
import { encrypt } from "@/utils/jsencrypt";
import intl from "react-intl-universal";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { setUserInfo} from "@/store/modules/user";
import { validatePassword, updateEmail } from "@/apis/user"
const { Search } = Input;
let timer = null
const ChangeEmail = ({ isChange, setIsChange, email, uuid, isUpdate, setIsUpdata }) => {
	const dispatch = useDispatch();
	let [count, setCount] = useState(0);
	const [captchaUuid, setCaptchaUuid] = useState('')
	const [form] = Form.useForm();

	useEffect(() => {
		return () => {
			timer && clearInterval(timer)
		}
	}, [])

	useEffect(() => {
		if (isChange) {
			form.setFieldsValue({
				password: "",
				newEmail: "",
				emailCode: ""
			})
		}
	}, [isChange])

	// 关闭忘记密码弹窗
	const cancelForget = () => {
		setIsChange(false)
	}

	const onFinish = (values) => {
		// 验证密码
		validatePassword({
			password: encrypt(values.password),
			userUuid: uuid
		}).then(res => {
			// 校验邮箱验证码
			checkEmailCode({
				captchaName: values.newEmail,
				captchaUuid: captchaUuid,
				captchaValue: values.emailCode
			}).then(res => {
				// 修改邮箱
				updateEmail({
					captchaRecord: res.data,
					newEmail: values.newEmail,
				}).then(res => {
					message.open({
						type: "success",
						content: intl.get("Operate successfully"),
						duration: 10,
					})
					timer && clearInterval(timer)
					cancelForget()
					setIsUpdata(!isUpdate)
							dispatch(
							  setUserInfo({
								email:values.newEmail,
							  })
							);
				}).catch(err => { })
			}).catch(err => { })
		})
	}

	// 获取验证码
	const getCode = (val) => {
		form.setFieldValue(
			"emailCode", ""
		)
		if (val) {
			timer && clearInterval(timer)
			getEmailCode({
				email: val,
				type: 1
			}).then(res => {
				message.open({
					type: "success",
					content: intl.get("Register.emailDes"),
					duration: 10,
				})
				setCaptchaUuid(res.data)
				// 倒计时
				let num = 120
				timer = setInterval(() => {
					setCount(num - 1)
					if (num === 0) {
						clearInterval(timer)
					}
					num = num - 1
				}, 1000)
			}).catch(err => { })
		}
	}

	return (
		<Modal title={intl.get('Change Bound Email')} open={isChange} footer={null} onCancel={cancelForget}>
			<Form
				style={{ marginTop: 35 }}
				layout="vertical"
				onFinish={onFinish}
				autoComplete="off"
				form={form}
				className={styles.formBox}
				size="large"
			>
				<Form.Item
					label={intl.get('Current Bound Email')}
				>
					<Input value={email} disabled />
				</Form.Item>

				<Form.Item
					label={intl.get('Login Password')}
					name="password"
					rules={[
						{
							required: true,
							message: intl.get("User.Please input your password"),
						}
					]}
				>
					<Input.Password />
				</Form.Item>

				<Form.Item
					label={intl.get("New Email")}
					name="newEmail"
					rules={[
						{
							required: true,
							message: intl.get("Please enter your new email address"),
						}, {
							type: 'email',
							message: intl.get("Email must be formatted correctly")
						}
					]}
				>
					<Search
						enterButton={count > 0 ? intl.get("User.Get code") + count : intl.get("User.Get code")}
						size="large"
						disabled={count > 0}
						onSearch={getCode}
					/>
				</Form.Item>
				<Form.Item
					label={intl.get("Register.Email verification code")}
					name="emailCode"
					rules={[
						{
							required: true,
							message: intl.get("Register.Please enter the six digit code received by email"),
						},
					]}
				>
					<Input.OTP />
				</Form.Item>
				<Form.Item>
					<Button block type="primary" htmlType="submit">
						{intl.get("Share.Submit")}
					</Button>
				</Form.Item>
			</Form>
		</Modal>
	)
}
export default ChangeEmail
